import { SearchConfig } from '@shared/components/input/search/search-config.interface';

/**
 * Default Search Config
 */
export const SearchDefaultConfig: SearchConfig = {
  placeholder: 'system.search.placeholder',
  hotkeys: true,
}
